import { QuestionComponentProps } from "..";

import { NegativeTechnologiesSelector } from "./components/NegativeTechnologiesSelector";

export function NegativeTechnologies({
  setNextEnabled,
}: QuestionComponentProps): React.ReactElement {
  return (
    <NegativeTechnologiesSelector
      onPreferenceSet={(isPreferenceSet: boolean) =>
        setNextEnabled?.(isPreferenceSet)
      }
    />
  );
}
